<template lang="html">
  <v-container wrap style="padding:  0px !important; margin: 0px;">
  <v-layout row wrap style="background-color: none !important;">
    <v-flex xs12 class="setBgHeaderRegis widthfull" :style="{background: backgroundText}">
      <v-layout align-center justify-center row wrap style="height: 30px;">
        <v-flex xs12>
          <v-layout align-center justify-center row wrap>
            <h3 class="centerDiv mt-1" style="color: white">แชทกับเรา</h3>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs12 class="setHeightChatBoxRegis" style="height: 100vh;">
      <div style="background: white !important; height: 100vh;">
      <v-layout row wrap align-center justify-start style="padding-left: 16px; padding-right: 16px;padding-top: 10px; padding-bottom: 10px;">
        <!-- arrow_back_ios -->
        <v-btn flat icon color="primary" @click="backPage">
          <v-icon>arrow_back_ios</v-icon>
        </v-btn>
        <h4>ข้อมูลเกี่ยวกับการสนทนา</h4>
      </v-layout>
      <v-layout column wrap align-center justify-start style="padding-left: 16px; padding-right: 16px;padding-bottom: 10px;">
        <v-form v-model="valid" ref="form" style="width: 100% !important;">
          <v-text-field
            label="เลขทิคเก็ต (Ticket Code)"
            v-model="con_code"
            :rules="ticketcodeRules"
            single-line
            solo
            :style="'width: 100% !important; color: ' + backgroundText + ' !important;'"
            @keyup.enter="login()"
          ></v-text-field>
          <v-text-field
            label="อีเมล (E-mail)"
            v-model="email"
            :rules="emailRules"
            single-line
            solo
            :style="'width: 100% !important; color: ' + backgroundText + ' !important;'"
            required
            @keyup.enter="login()"
            ></v-text-field>
            <v-layout row wrap align-center justify-center >
              <v-btn dark :style="'background-color: ' + backgroundText + ' !important; width: 100%; border-radius: 7px;'" @click="login()" :loading="loading" :disabled="!valid">เริ่มการแชท</v-btn>
            </v-layout>
        </v-form>
      </v-layout>
    </div>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import { sync } from 'vuex-pathify'
const theme = require('../assets/theme')
export default {
  data: () => ({
    theme,
    bodyclose: '',
    ticketcode: '',
    backgroundText: '',
    backgroundButtonchat: '',
    backgroudHeader: '',
    servicename: '',
    valid: false,
    subject: '',
    name: '',
    email: '',
    phone: '',
    textcomment: '',
    loading: false,
    tokenservice: '',
    Bearer: 'Bearer ',
    headers: '',
    body: '',
    message: '',
    room: '',
    tokenuser: '',
    con_code: '',
    phoneRules: [
      v => (!!v && v.length === 10) || 'กรุณากรอกตัวเลขให้ครบ 10 หลัก',
      v => !!v || 'กรุณากรอกข้อมูลเป็นตัวเลข',
      v => /^0[0-9]{9}/.test(v) || 'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง'
    ],
    ticketcodeRules: [
      v => !!v || 'กรุณากรอกเลขทิคเก็ต'
      // v => ((!v && v.length < 6) || /^[^\W_]+$/.test(v)) || 'ไม่สามารถใช้อักขระพิเศษได้',
      // v => (!!v && v.length >= 6) || 'กรุณาใส่ตัวอักษรอย่างน้อย 6 ตัว',
      // v => /^([a-z])+$/.test(v) || /^((?=.*[a-zA-Z])(?=.*[0-9]).{6,})+$/.test(v) || 'กรุณากรอกตัวอักษรเป็นภาษาอังกฤษ a-z และ 0-9 เท่านั้น'
    ],
    emailRules: [
      v => !!v || 'กรุณากรอกอีเมล์',
      v => !v || (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || 'รูปแบบอีเมล์ไม่ถูกต้อง'
    ],
    subjectRules: [
      v => !!v || 'กรุณากรอกหัวข้อปัญหา'
    ],
    textcommentRules: [
      v => !!v || 'กรุณากรอกข้อความเริ่มการสนทนา'
    ]
  }),
  computed: {
    ...sync('*')
  },
  methods: {
    backPage () {
      var servicename = this.$route.params.servicename
      var key = this.$route.params.key
      this.$router.push('/register/' + servicename + '/' + key)
    },
    login () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.headers = {headers: {'Authorization': this.tokenservice}}
        this.body = {email: this.email, con_code: this.con_code}
        this.axios.post(process.env.APImanage + '/get_room_by_concode', this.body, this.headers).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            var servicename = response.data.data.service_name
            var concode = response.data.data.con_code
            var tokenroom = response.data.data.tokenroom
            // localStorage.setItem('nickname', response.data.data.nickname)
            // localStorage.setItem('subject', response.data.data.subject)
            // localStorage.setItem('tokenroom', response.data.data.tokenroom)
            // localStorage.setItem('tokenuser', response.data.data.tokenuser)
            // localStorage.setItem('servicename', response.data.data.service_name)
            // localStorage.setItem('con_code', response.data.data.con_code)
            // localStorage.setItem('status_login', 'T')
            // localStorage.setItem('status_room', response.data.data.status.status)
            this.myname = response.data.data.nickname
            this.mysubject = response.data.data.subject
            this.mytokenroom = response.data.data.tokenroom
            this.mytokenuser = response.data.data.tokenuser
            this.myservicename = response.data.data.service_name
            this.myconcode = response.data.data.con_code
            this.mystatusroom = response.data.data.status.status
            this.mystatuslogin = 'T'
            if (response.data.data.status.status === 'close') {
              this.$swal({
                title: '<div style="font-size: 18px;">ห้องสนทนาถูกปิดแล้ว ต้องการดำเนินการต่อ ?</div>',
                text: '',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#7f7f7f',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
              }).then((result) => {
                if (result.value) {
                  this.$router.push('/chat/' + servicename + '/' + concode + '/' + tokenroom)
                  // this.bodyclose = {tokenroom: response.data.data.tokenroom, tokenuser: response.data.data.tokenuser}
                  // this.axios.post(process.env.APImanage + '/close_ticket_by_guest', this.bodyclose, this.headers).then((responsed) => {
                  //   console.log(responsed.data)
                  //   if (responsed.data.status === 'success') {
                  //     this.$router.push('/rating/' + servicename + '/' + concode + '/' + tokenroom)
                  //   } else {
                  //     console.log('close ticket error')
                  //   }
                  // })
                }
              })
              this.loading = false
            } else {
              this.$router.push('/chat/' + servicename + '/' + concode + '/' + tokenroom)
            }
          } else {
            // console.log(response.data)
          }
          // if (response.data.status === 'success') {
          //   console.log(response.data)
          //   this.loading = false
          //   this.message = {user_id: response.data.data.tokenuser, to: response.data.data.tokenroom, type: 'text', message: this.textcomment}
          //   this.axios.post(process.env.APImanage + '/push_message', this.message, this.headers).then((responsed) => {
          //     console.log(responsed.data)
          //     localStorage.setItem('nickname', this.name)
          //     localStorage.setItem('subject', this.subject)
          //     localStorage.setItem('tokenroom', response.data.data.tokenroom)
          //     localStorage.setItem('tokenuser', response.data.data.tokenuser)
          //     localStorage.setItem('servicename', response.data.data.service_name)
          //     localStorage.setItem('con_code', response.data.data.con_code)
          //     localStorage.setItem('status_login', 'T')
          //     this.$router.push('/chatbox/' + response.data.data.tokenroom)
          //   })
          // } else {
          //   localStorage.setItem('status_login', 'F')
          //   this.$router.push('/register')
          //   console.log(response.data)
          // }
        }).catch(error => {
          console.log(error)
          this.loading = false
          if (error.response.data.message === 'Authentication not match this room.') {
            this.$swal('', 'เลขทิคเก็ตนี้ไม่สามารถใช้งานได้ กรุณาตรวจสอบให้ถูกต้อง', 'warning')
          } else if (error.response.data.message === 'Email not match') {
            this.$swal('', 'อีเมลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง', 'warning')
          } else if (error.response.data.message === 'Unknow room.') {
            this.$swal('', 'เลขทิคเก็ตไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง', 'warning')
          } else {
            this.$swal('', 'ขออภัย ขณะนี้ระบบขัดข้องกรุณาลองใหม่ในภายหลัง', 'warning')
          }
        })
      }
    }
  },
  created () {
    this.tokenservice = 'Bearer ' + this.$route.params.key
    var servicename = this.$route.params.servicename
    if (this.theme[servicename].authen === this.$route.params.key) {
      this.backgroundText = this.theme[servicename].background
      this.colortext = this.theme[servicename].background
    } else {
      this.backgroundText = '#01579b'
      this.colortext = '#01579b'
    }
  }
}
</script>

<style lang="css" scoped>
>>>.v-text-field.v-text-field--solo .v-input__control {
  min-height: 40px;
}
>>>.v-input__slot {
  border-width: thin !important;
  border-style: solid !important;
  border-radius: 8px !important;
  border-color: #808080a6 !important;
  box-shadow: none !important;
}
a {
  color: white;
}
a:hover {
  color: white;
  text-decoration: underline;
}
.setHeightChatBoxRegis {
  height: calc(100vh - 55px);
  max-height: calc(100vh - 55px);
  /*overflow-y: scroll;*/
}
.setBgHeaderRegis {
  background-color: #01579B;
  height: 30px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.chatBoxFriendRegis {
  word-wrap: break-word;
  max-width: 50%;
  border-radius: 25px;
  background: #E0E0E0;
  padding: 12px;
}
.chatBoxRegis {
  word-wrap: break-word;
  max-width: 50%;
  border-radius: 25px;
  background: #B3E5FC;
  color: black;
  padding: 12px;
}

textarea:focus{
  outline: none !important;
  box-sizing: border-box !important;
  resize: none;
}
.textBoxRegis {
  height: 90px !important;
  border-style: solid solid solid solid !important;
  border-width: 1px;
  border-radius: 7px;
  border-color: #ccc !important;
}

.colorFooterMenuRegis {
  color: #424242
}
input[type=text], select {
    width: 100%;
    padding: 8px 10px;
    margin: 8px 0;
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 7px;
    box-sizing: border-box;
}

input[type=submit] {
    width: 100%;
    background-color: #4CAF50;
    color: white;
    padding: 14px 20px;
    margin: 8px 0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

input[type=submit]:hover {
    background-color: #45a049;
}

/*div {
    border-radius: 5px;
    background-color: #f2f2f2;
    padding: 20px;
}*/
</style>



// WEBPACK FOOTER //
// src/components/Continuechat.vue